import { Fragment, ReactElement } from 'react';
import RegistrationCivilUnionDetailNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-civil-union/detail';

const RegistrationCivilUnionDetailNotificationsPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCivilUnionDetailNotificationsCivilStatusShared />
    </Fragment>
  );
};

RegistrationCivilUnionDetailNotificationsPage.displayName =
  'Research Civil Union Detail Notifications Page component';

export default RegistrationCivilUnionDetailNotificationsPage;
